export default __webpack_public_path__ + "static/media/Group 11607.cb10704a.svg";